import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  constructor( private alertCtrl: AlertController) {}

  deepCopy(obj: any) {
    if (typeof obj !== 'object' || obj === null) {
      return obj;
    }
    
    if (Array.isArray(obj)) {
      return obj.map(item => this.deepCopy(item));
    }
    
    const newObj = {};
    for (const key in obj) {
      newObj[key] = this.deepCopy(obj[key]);
    }
    
    return newObj;
  }

    async handleErrors(res: any): Promise<any> {
      if (res.status && res?.ok === false) {
        switch (res.status) {
          case 401:
            const unauthorized = await this.alertCtrl.create({
              header: '401 Error',
              message: res?.error ? res?.error[0] : 'Unauthorized',
              buttons: ['OK']
            });
            await unauthorized.present();
            return false;
          case 403:
            const accessDenied = await this.alertCtrl.create({
              header: '403 Error',
              message: 'Access Denied',
              buttons: ['OK']
            });
            await accessDenied.present();
            return false;
          case 404:
            const notFound = await this.alertCtrl.create({
              header: '404 Error',
              message: 'Not Found',
              buttons: ['OK']
            });
            await notFound.present();
            return false;
          case 500:
            const serverError = await this.alertCtrl.create({
              header: '500 Error',
              message: 'Internal Server Error',
              buttons: ['OK']
            });
            await serverError.present();
            return false;
          default:
            return res;
        }
      } else if (res.name === 'TimeoutError') {
        const timeoutError = await this.alertCtrl.create({
          header: 'Timeout Error',
          message: 'Request timed out',
          buttons: ['OK']
        });
        await timeoutError.present();
        return false;
      } else {
        return res;
      }
    }


}